var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1576 36.0336C36.4196 35.86 36.7205 35.7539 37.0335 35.7247C37.3465 35.6956 37.6619 35.7443 37.9515 35.8665L49.0942 40.8557C49.4656 41.0198 49.7744 41.2989 49.9751 41.6518C50.1757 42.0047 50.2575 42.4128 50.2085 42.8157C49.8414 45.5564 48.4912 48.0707 46.409 49.8916C44.3269 51.7125 41.6542 52.716 38.8875 52.7159C30.3676 52.7159 22.1967 49.3333 16.1722 43.3122C10.1477 37.2911 6.7632 29.1248 6.7632 20.6098C6.75794 17.845 7.75883 15.1726 9.57934 13.0908C11.3998 11.0091 13.9157 9.66003 16.6579 9.29518C17.0613 9.24435 17.4702 9.32535 17.8237 9.52608C18.1772 9.72681 18.4562 10.0365 18.619 10.4088L23.6109 21.5452C23.7348 21.8318 23.7855 22.1447 23.7582 22.4558C23.731 22.7668 23.6268 23.0663 23.4549 23.327L18.4072 29.3183C18.23 29.5902 18.1257 29.903 18.1042 30.2267C18.0827 30.5504 18.1449 30.8742 18.2847 31.167C20.542 35.4634 24.0662 38.9623 28.3799 41.1897C28.6747 41.3262 28.9998 41.3845 29.3237 41.3592C29.6476 41.3338 29.9596 41.2256 30.2296 41.045L36.1576 36.0336Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.455 26.096C47.3535 26.096 51.3246 22.1272 51.3246 17.2314C51.3246 12.3357 47.3535 8.36688 42.455 8.36688C37.5565 8.36688 33.5854 12.3357 33.5854 17.2314C33.5854 22.1272 37.5565 26.096 42.455 26.096Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.728 23.5013L53.8648 28.6351",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.b6b7bb3a179c3322c5c42dc727c430a8.svg";
export { ForwardRef as ReactComponent };